<!-- añadir / eliminar claves Agencias Afectas  -->

<template>
  <div class="agenMClaves">
    <v-dialog
      content-class="modal"
      v-model="modal"
      persistent>
        <div>
          <v-sheet :elevation="4">        
            <!-- Cabecera -->
            <div class="cabecera">
              <baseHeader
                :cfg="$cfe.headers.mto"
                :titulo='titulo'
                @onEvent="$emit('onEvent', { accion:6 })">
              </baseHeader>                  
            </div>


            <!-- Contenido -->
            <div class="contenedor" style="width:500px"> 
              <div class="columna">
                <baseBtraExtra class="conflex"
                  :modulo="btExtCfg"           
                  @onEvent="execAccion">
                </baseBtraExtra>
                              
                <v-textarea
                  v-bind="$textarea"
                  style="padding-top:10px"
                  v-model="txt"
                  label="Introduce la/s clave/s de producción separada/s por comas"
                  rows="3"
                  no-resize>
                </v-textarea>

              </div>
            </div>
          </v-sheet> 
      </div>
    </v-dialog>
  </div>
</template>



<script>

  import { mixBtras } from "@/mixins/mixBtras";
  import baseHeader from "@/base/baseHeader";
  import baseBtraExtra from "@/base/baseBtraExtra";
     
  export default {
    mixins: [mixBtras],
    components: { baseHeader, baseBtraExtra },
    props: {
      accionClave: { type:Number, default: 0},
      masterStore: { type: String, default: '' },
      masterRecordField: { type: String, default: 'id' },
    },

    data() {
      return {
        modal:true,
        titulo:'',
        btExtCfg: JSON.parse(JSON.stringify(this.$cfe.btra.EXTRA)),
        txt:'',
        apiArgs:{}        
      };
    },


    created() {
      this.iniDataParticular();
      this.botonerasSet();
      this.iniDataApi();
    },


    methods: {
      iniDataParticular() {
        console.log("DEV apdMZonas ********************** (iniDataParticular)");

        // título ventana
        this.titulo = (this.accionClave==1? 'Añadir' : 'Eliminar') + ' Claves';

        // añade botones extra
        this.btExtCfg.btnsAccion= [
          { accion:'guardar', btn: "guardar" }         
        ];
      },


      // defino todas las API calls
      iniDataApi() {
        this.apiArgs= {
          claves: ['', 'claves', { fnt:'', age:0, claves:'' }, "apds"],
        }
      },


      // configura botonera
      botonerasSet() {  
        this.btnSet(this.btExtCfg, "guardar",{ view:true, disabled: false });
        this.btnSet(this.btExtCfg, "pegar",{ view:true, disabled: this.cps? false:true  });
      },


      // acción botón guardar
      async guardar() {        
        if (!this.txt) {
          this.$root.$alert.open('Debe introducir una o varias claves de producción', 'error');
          return;
        }
        
        // llamada API
        let param= { apiArg:this.apiArgs.claves, args:{ 
          fnt:this.accionClave==1? 'set' : 'anular',
          age:this.masterField,      
          claves:this.txt
        }};   
        
        let apiResult = await this.$store.dispatch("apiCall", param);
        
        // 
        if (apiResult.sql.error) {
          this.$root.$alert.open(apiResult.sql.msg, 'error');
          return;
        }


        this.$root.$alert.open('Operación realizada correctamente', 'success', 1800);

        // actualizo lista de zonas y salgo
        this.$emit('update', apiResult.r[0] );        
        this.$emit('onEvent', { accion:6 });
      },

    
      execAccion(evt) {
        let accion = evt.accion;
        if (this.$isFunction(this[accion])) this[accion](evt);
      }

    },


    computed: {
      // devuelvo el valor del campo masterRecordField del record sincronizado      
      masterField() {      
        if (!this.masterStore) return null;
        if (!this.masterSyncRecord) return null;
        if (typeof this.masterSyncRecord[this.masterRecordField] === 'undefined') return 0;
        return this.masterSyncRecord[this.masterRecordField];
      },

      // records seleccionados del componente maestro asociado
      masterSyncRecord() {
        return this.$store.getters[this.masterStore + "/syncRecord"];
      },

    }

  };
</script>
